import Basic from './Basic';
import Advanced from './Advanced';
import ThresholdTable from './ThresholdTable';

export default {
  Basic,
  Advanced,
  ThresholdTable,
};
